/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Community_Public_RoadmapInputs */

const en_us2_community_public_roadmap = /** @type {(inputs: Community_Public_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`The roadmap on the site`)
};

const pt_br2_community_public_roadmap = /** @type {(inputs: Community_Public_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O roadmap no site`)
};

const es_419_community_public_roadmap = /** @type {(inputs: Community_Public_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`El roadmap en el sitio`)
};

const pt_pt2_community_public_roadmap = /** @type {(inputs: Community_Public_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`O roadmap no site`)
};

const fr_fr2_community_public_roadmap = /** @type {(inputs: Community_Public_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La feuille de route sur le site`)
};

const de_de2_community_public_roadmap = /** @type {(inputs: Community_Public_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Die Roadmap auf der Website`)
};

const it_it2_community_public_roadmap = /** @type {(inputs: Community_Public_RoadmapInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`La roadmap sul sito`)
};

/**
* | output |
* | --- |
* | "The roadmap on the site" |
*
* @param {Community_Public_RoadmapInputs} inputs
* @param {{ locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }} options
* @returns {LocalizedString}
*/
const community_public_roadmap = /** @type {((inputs?: Community_Public_RoadmapInputs, options?: { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Community_Public_RoadmapInputs, { locale?: "en-US" | "pt-BR" | "es-419" | "pt-PT" | "fr-FR" | "de-DE" | "it-IT" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "pt-BR") return pt_br2_community_public_roadmap(inputs)
	if (locale === "es-419") return es_419_community_public_roadmap(inputs)
	if (locale === "pt-PT") return pt_pt2_community_public_roadmap(inputs)
	if (locale === "fr-FR") return fr_fr2_community_public_roadmap(inputs)
	if (locale === "de-DE") return de_de2_community_public_roadmap(inputs)
	if (locale === "it-IT") return it_it2_community_public_roadmap(inputs)
	return en_us2_community_public_roadmap(inputs)
});
export { community_public_roadmap as "community.public_roadmap" }